import * as http from 'utils/http';
import config from 'config';

const freezeJourney = async (journeyId) => {
  try {
    await http.put(`${config.BASE_URL}/api/mercury/journeys/${journeyId}/freeze/`);
    return true;
  } catch (e) {
    return false;
  }
};

const unfreezeJourney = async (journeyId) => {
  try {
    await http.put(`${config.BASE_URL}/api/mercury/journeys/${journeyId}/unfreeze/`);
    return true;
  } catch (e) {
    return false;
  }
};

export { freezeJourney, unfreezeJourney };
